// @flow
import i18n from 'i18next'
import { reactI18nextModule } from 'react-i18next'
import { includes, find, map } from 'lodash/collection'

import translationCA from './translations/ca'
import translationES from './translations/es'

export const availableLanguages = [
  { code: 'es', literal: 'ESP' },
  { code: 'ca', literal: 'CAT' }
]

export const getLanguageFromPath = () => {
  const pathName = window.location.pathname
  const getLanguageFromPathAtHome = find(map(availableLanguages, language => language.code), language => `/${language}` === pathName)
  const getLanguageFromPath = find(map(availableLanguages, lang => lang.code), code => includes(pathName.substring(0, 4), `/${code}/`))

  if (getLanguageFromPathAtHome) return getLanguageFromPathAtHome
  if (getLanguageFromPath) return getLanguageFromPath

  return 'es'
}

i18n
  .use(reactI18nextModule)
  .init({
    lng: getLanguageFromPath(),
    fallbackLng: {
      es: ['es'],
      ca: ['ca'],
      default: availableLanguages.map(language => language.code)
    },
    resources: {
      es: { translation: translationES },
      ca: { translation: translationCA }
    }
  })
